/*
 * @Author: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @Date: 2024-11-23 19:08:06
 * @LastEditors: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @LastEditTime: 2024-12-25 16:02:48
 * @FilePath: \szsc_ipark_device_admin(contractadmin)\src\area-dcits\api\workflow.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https:// github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import http from '@/api/base'

let str = '/platform'
// 获取平台cookie
const getPlatCookie = () => {
  let param = {
    platformFlag: true
  }
  let cookies = document.cookie.split(';')
  let thisCookie = ''
  for (let i = 0; i < cookies.length; i++) {
    let cookie = cookies[i].trim()
    if (cookie.indexOf('passport-sso') !== -1) {
      let arr = cookie.split('=')
      thisCookie = arr[1]
    }
  }
  return http.post(str + '/pingAn/loginToken/' + thisCookie, param)
}

export default {
  getPlatCookie
}



// WEBPACK FOOTER //
// ./src/area-dcits/api/platGateway.js